import React from "react";
import { SALES_ORDER_WIDGETS, GenericSection } from './sales-order';
import { ITEM_WIDGETS } from './item';
import { STOCK_ENTRY_WIDGETS } from './stock-entry';
import { ITEM_PRICE_WIDGETS } from './item-price';
import type { ShopifySectionWidgetProps } from './sales-order/types';

/**
 * Result type for widget registry lookup
 */
export interface ExperienceWidgets {
  map: Record<string, React.ComponentType<ShopifySectionWidgetProps>>;
  fallback: React.ComponentType<ShopifySectionWidgetProps>;
}

/**
 * Get Shopify experience widget map for a given doctype.
 * 
 * This is the ONLY place where doctype routing logic lives.
 * Keeps renderers pure and testable.
 * 
 * Returns both the widget map and fallback component together
 * to prevent mismatched fallbacks later.
 * 
 * @param doctype - The DocType name (e.g., "Sales Order", "Item", "Customer")
 * @returns Widget map and fallback component for the doctype
 */
export function getShopifyExperienceWidgets(
  doctype: string
): ExperienceWidgets {
  if (doctype === "Sales Order") {
    return {
      map: SALES_ORDER_WIDGETS,
      fallback: GenericSection,
    };
  }
  
  if (doctype === "Item") {
    return {
      map: ITEM_WIDGETS,
      fallback: GenericSection,
    };
  }
  
  if (doctype === "Stock Entry") {
    return {
      map: STOCK_ENTRY_WIDGETS,
      fallback: GenericSection,
    };
  }
  
  if (doctype === "Item Price") {
    return {
      map: ITEM_PRICE_WIDGETS,
      fallback: GenericSection,
    };
  }
  
  // Future: Add more doctypes here
  // if (doctype === "Customer") {
  //   return {
  //     map: CUSTOMER_WIDGETS,
  //     fallback: GenericSection,
  //   };
  // }
  
  // Fallback: return empty map with GenericSection as default
  return {
    map: {},
    fallback: GenericSection,
  };
}


